<script setup lang="ts">
import { orgManageApi } from '@/api';
import { OrgInfo } from '@/api/modules/org';

defineOptions({
  inheritAttrs: true,
});

const props = defineProps<{
  modelValue: OrgInfo;
}>();
const emit = defineEmits(['update:modelValue']);

const list = ref<OrgInfo[]>([]);
const fullList = computed(() => {
  if (props.modelValue?.orgName) {
    const hasOrg = list.value.find(item => item.orgName === props.modelValue.orgName);
    if (hasOrg) {
      return list.value;
    } else {
      return [props.modelValue, ...list.value];
    }
  }
  return list.value;
});
const remoteMethod = (orgName: string) => {
  orgManageApi.queryOrgByPage({ current: 1, size: 50, orgName, orgFilter: 1 }).then(res => {
    list.value = res.records || [];
  });
};
</script>
<template>
  <el-select
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    placeholder="请选择学校"
    filterable
    remote
    :remote-method="remoteMethod"
    value-key="orgId"
  >
    <el-option v-for="item in fullList" :key="item.orgId" :label="item.orgName" :value="item" />
  </el-select>
</template>
